import React from "react";
import styles from "./LoanSummary.module.scss";
import { IoIosArrowBack } from "react-icons/io";
import { Link } from "react-router-dom";

export default function LoanSummary({ amount }) {
  return (
    <div className={styles.loanSummary}>
      <div className={styles.header}>
        {/* <Link to="/home" className={styles.backArrow}>
          <IoIosArrowBack size={34} color="#ffffff" />
        </Link> */}
        <p>Repayment</p>
      </div>

      <div className={styles.paymentAmount}>
        <p>Total Re-payment Amount</p>
        <h3>₹{amount}</h3>
      </div>
    </div>
  );
}
